import { useTranslation } from 'react-i18next';

import { StyledPageHeader, PageHeaderTitle } from './style';

export const PageHeader = ({ titleTranslationKey, onBack, extra }) => {
  const { t } = useTranslation();

  return <StyledPageHeader title={<PageHeaderTitle>{t(titleTranslationKey)}</PageHeaderTitle>} onBack={onBack} extra={extra} />;
};
